import { render, staticRenderFns } from "./SurveyLinkCard.vue?vue&type=template&id=3a64e1cd&scoped=true&"
import script from "./SurveyLinkCard.vue?vue&type=script&lang=js&"
export * from "./SurveyLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./SurveyLinkCard.vue?vue&type=style&index=0&id=3a64e1cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a64e1cd",
  null
  
)

export default component.exports